import request from '@/utils/request';


export const maindata = (params) => {
  return request('/org_api/v1/report/maindata', {
    method: 'get',
    params
  })
}

export const datatends = (params) => {
  return request('/org_api/v1/report/datatends', {
    method: 'get',
    params
  })
}

export const productrank = (params) => {
  return request('/org_api/v1/report/productrank', {
    method: 'get',
    params
  })
}

export const visacountrank = (params) => {
  return request('/org_api/v1/report/visacountrank', {
    method: 'get',
    params
  })
}


export const keywordrank = (params) => {
  return request('/org_api/v1/report/keywordrank', {
    method: 'get',
    params
  })
}
